module.exports = __webpack_public_path__ + "static/media/x-white.dd6f3f31.png";